import React from 'react';
import { Skeleton } from '../Skeleton';

const ChannelSectionLoader = () => {
  return (
    <div className="w-100 voteCard rounded d-flex justify-content-between align-items-center">
      <div className="voteCardLeft d-flex align-items-center">
        <div className="voteLogoPic rounded-circle">
          <Skeleton variant="circular" width={'100%'} height={'100%'} />
        </div>
        <div className="voteDetails">
          <h5 className="fs-2 fw-semibold text-black text-start mb-2">
            <Skeleton variant="text" width={200} height={30} />
          </h5>
          <p className="fs-16 fw-medium text-dark text-start">
            <Skeleton variant="text" width={150} height={30} />
          </p>
        </div>
      </div>
    </div>
  );
};

export default ChannelSectionLoader;
